import { Check } from 'lucide-react';

import { components } from '@/types/strapi';
import { TwoColumnPopupProps } from './TwoColumnPopup';

interface TwoColumnNewsletterProps
	extends Omit<TwoColumnPopupProps, 'content'> {
	content: components['schemas']['PopupTwoColumnImageNewsletterSignupComponent'];
}
export const TwoColumnImageNewsletterSignup = ({
	content,
}: TwoColumnNewsletterProps) => {
	return (
		<div className="newsletter-signup">
			<div className="mt-2 space-y-5">
				<div className="mb-2 space-y-2">
					{content.features?.map((feat, ind: number) => (
						<div className="mb-3 flex items-start" key={ind}>
							<div className="mr-3 flex-shrink-0 rounded-full bg-blue-100 p-1.5">
								<Check className="h-3 w-3 text-blue-500" />
							</div>
							<span className="font-thin text-gray-800">
								{feat.text}
							</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
